import { AppState } from "@Store/index";
import { shallowEqual, useSelector } from "react-redux";
import styles from "./PropertyPolicies.module.scss";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import wrapperHOC from "@Utils/wrapperHOC";
import HouseRulePolicies from "./components/HouseRulePolicies";
import useTranslationHook from "hooks/useTranslationHook";

const HouseRules = ({ isDesktop = false, inventoryFromProps = {} }: any) => {
  const { inventory } = useSelector(
    ({ propertyPageData }: AppState) => ({
      inventory: propertyPageData?.data,
    }),
    shallowEqual,
  );
  const description: Record<string, any> = {};
  const { t } = useTranslationHook();

  if (inventory || inventoryFromProps) {
    const allDescriptions = inventory?.description ?? inventoryFromProps?.description ?? [];

    // Include both house rules and cancellation policies
    description.houseRules = allDescriptions.filter(
      (item: any) =>
        item.name === "house_rules" ||
        item.name_en === "house_rules" ||
        item.name === "cancellation_policy" ||
        item.name_en === "cancellation_policy",
    );
  }

  return (
    <>
      <div
        className={formatClassNames(styles.listStyle, isDesktop && styles.desktop)}
        id="house_rules"
      >
        <HouseRulePolicies
          dataTestId="House Rules"
          title={t("House Rules")}
          gtagEventAction="house_rules"
          policies={description.houseRules || []}
          isDesktop={isDesktop}
          initialListCount={3}
          isHouseRules
        />
      </div>
    </>
  );
};

export default wrapperHOC(HouseRules, {
  componentName: "HouseRules-PropertyPage",
  showForChina: true,
});
